/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2022-09-27 10:33:30
 *
 *******************************************************/
// @flow
import React, { Component } from 'react';
import { Icon, TextField } from '@shopify/polaris';
import { SearchMinor } from '@shopify/polaris-icons';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

type Props = {
  value: string,
  selectedTab: number,
  onChange: (keyword: string) => void,
  onClear: () => void,
  handleKeyUp: (event: any) => void,
  handleKeyDown: (event: any) => void
};

type ComposedProps = WithI18nProps & Props;

type State = {};

class Search extends Component<ComposedProps, State> {
  state = {};

  shouldComponentUpdate(nextProps) {
    if (this.props.value !== nextProps.value || this.props.selectedTab !== nextProps.selectedTab) {
      return true;
    }
    return false;
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.selectedTab !== nextProps.selectedTab && this.props.value !== nextProps.value) {
      const inputDom = document.querySelector('#search-manual-recommendation');
      setTimeout(() => {
        inputDom && inputDom.focus();
      }, 0);
    }
  }

  render() {
    const { i18n, value, onChange, onClear, handleKeyUp, handleKeyDown } = this.props;

    return (
      <div className="searchField">
        <div className="search" onKeyDown={handleKeyDown} onKeyUp={handleKeyUp}>
          <TextField
            id="search-manual-recommendation"
            onChange={onChange}
            value={value}
            clearButton
            onClearButtonClick={onClear}
            prefix={<Icon source={SearchMinor} color="base" />}
            placeholder={i18n.translate(
              'AdminHTML.Recommendation.ManualRecommendation.Dashboard.search_Placeholder'
            )}
            autoComplete="off"
          />
        </div>
      </div>
    );
  }
}

export default withI18n()(Search);
